module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAClSURBVDiNrZJRDcIwFEVPCQImYQ6QwJCAAyQMBUhAAsERDjYHw8HhpyNNWLc24X7e9+55aXPhH1I7dbBck9qlgEntKw726gCwj14DHNVDIaMBWoAQiVa9OSqEEHaVmRF4pUYNYAROwPNnUvDrg9qql9RcAjzUe0k4B5iXb1vhHCAN9WvhNcDm5RSw1oN3LExWaQ/GhflqOB749uA6G4UagXPFfl4fGXpkfmTC2tMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/get.png
// module id = +YNo
// module chunks = 1